import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const institutesLinks = [
    { name: 'Residential School Institutions', path: '/services/residential-school' },
    { name: 'Residential PU Colleges & Integrated Coaching Campuses', path: '/services/pu-laundry' },
    { name: 'Universities, Medical & Higher Education Institutions', path: '/services/universities-laundry' },
    { name: 'Hospitality & Industrial Institutions', path: '/services/industrial-laundry' },
  ];

  const navLinkClass = (active) =>
    `no-underline text-base font-medium transition-colors ${active ? 'text-blue-900' : 'text-gray-700 hover:text-blue-900'
    }`;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-2 md:py-3">

          {/* Logo */}
          <Link to="/" className="flex items-center no-underline">
            <img
              src="/logo.png"
              alt="Venus Fabcare Logo"
              className="h-12 md:h-20 lg:h-24 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className={navLinkClass(isActive('/'))}>Home</Link>
            <Link to="/about" className={navLinkClass(isActive('/about'))}>About Us</Link>
            <Link to="/process" className={navLinkClass(isActive('/process'))}>Our Process</Link>

            {/* Institutes Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <button
                className={`flex items-center no-underline text-base font-medium transition-colors ${location.pathname.startsWith('/services')
                  ? 'text-blue-900'
                  : 'text-gray-700 hover:text-blue-900'
                  }`}
              >
                Institutes We Serve
                <ChevronDown
                  className={`ml-1 h-4 w-4 transition-transform ${isDropdownOpen ? 'rotate-180' : ''
                    }`}
                />
              </button>

              {isDropdownOpen && (
                <div className="absolute top-full left-0 pt-4 w-64 animate-in fade-in slide-in-from-top-2 duration-200">
                  <div className="bg-white p-2 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-gray-100 flex flex-col gap-1 ring-1 ring-black/5">
                    {institutesLinks.map((link) => (
                      <Link
                        key={link.path}
                        to={link.path}
                        className="block px-4 py-2.5 text-sm font-medium text-gray-700 hover:text-blue-900 hover:bg-blue-50 rounded-lg transition-all duration-200 no-underline"
                      >
                        {link.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link to="/contact" className={navLinkClass(isActive('/contact'))}>
              Contact
            </Link>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <Link to="/contact" className="no-underline">
              <Button className="bg-blue-900 hover:bg-blue-800 text-white">
                Get in Touch
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-3 border-t border-gray-200 bg-white">
            <div className="flex flex-col space-y-1">
              <Link to="/" className={`${navLinkClass(isActive('/'))} py-2.5 px-2 rounded-lg hover:bg-gray-50`} onClick={() => setIsMenuOpen(false)}>Home</Link>
              <Link to="/about" className={`${navLinkClass(isActive('/about'))} py-2.5 px-2 rounded-lg hover:bg-gray-50`} onClick={() => setIsMenuOpen(false)}>About Us</Link>
              <Link to="/process" className={`${navLinkClass(isActive('/process'))} py-2.5 px-2 rounded-lg hover:bg-gray-50`} onClick={() => setIsMenuOpen(false)}>Our Process</Link>

              <div className="space-y-1 pt-1">
                <div className="text-sm font-semibold text-gray-500 uppercase tracking-wide px-2 pt-1 pb-0.5">
                  Institutes We Serve
                </div>
                {institutesLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="block pl-4 pr-2 py-2 text-sm text-gray-700 no-underline hover:text-blue-900 hover:bg-blue-50 rounded-lg"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.name}
                  </Link>
                ))}
              </div>

              <Link to="/contact" className={`${navLinkClass(isActive('/contact'))} py-2.5 px-2 rounded-lg hover:bg-gray-50`} onClick={() => setIsMenuOpen(false)}>
                Contact
              </Link>

              <div className="pt-2">
                <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                  <Button className="w-full bg-blue-900 hover:bg-blue-800 text-white">
                    Get in Touch
                  </Button>
                </Link>
              </div>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;